export default __webpack_public_path__ + "static/media/explore9.4e90fe2f.png";